module.exports = __webpack_public_path__ + "img/icon-atencion-blue.d46c401b.svg";